import React from 'react';
import { useTheme } from 'styled-components';
import CoreSvg from '../CoreSvg';
import { IconBlackButton, IconButton, IconGrayButton, IconPrimaryButton } from './style';
import { IIconButton } from './type';

const CoreIconButton = ({
	color_type = 'primary',
	style_type = 'filled',
	children,
	text,
	_disabled = false,
	_onClick,
	_ref,
	_margin,
	is_loading,
}: IIconButton) => {
	const theme = useTheme();

	if (color_type === 'primary')
		return (
			<IconPrimaryButton
				style_type={style_type}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _disabled) return;
					_onClick ? _onClick(e) : '';
				}}
				margin={_margin}
				ref={_ref}
			>
				<span>
					<CoreSvg
						_fill={
							style_type === 'filled'
								? theme.colors.gray.gray_white
								: theme.colors.primary.primary80_darken
						}
					>
						{children}
					</CoreSvg>
					{text}
				</span>
			</IconPrimaryButton>
		);
	if (color_type === 'gray')
		return (
			<IconGrayButton
				style_type={style_type}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _disabled) return;
					_onClick ? _onClick(e) : '';
				}}
				ref={_ref}
				margin={_margin}
			>
				<span>
					<CoreSvg
						_fill={
							style_type === 'filled'
								? theme.colors.gray.gray_white
								: theme.colors.gray.gray80_text
						}
					>
						{children}
					</CoreSvg>
					{text}
				</span>
			</IconGrayButton>
		);
	if (color_type === 'black')
		return (
			<IconBlackButton
				style_type={style_type}
				disabled={_disabled}
				onClick={(e) => {
					if (is_loading || _disabled) return;
					_onClick ? _onClick(e) : '';
				}}
				margin={_margin}
				ref={_ref}
			>
				<span>
					<CoreSvg
						_fill={
							style_type === 'filled'
								? theme.colors.gray.gray_white
								: theme.colors.gray.gray_black
						}
					>
						{children}
					</CoreSvg>
					{text}
				</span>
			</IconBlackButton>
		);
	if (color_type === 'none')
		return (
			<IconButton
				_disabled={_disabled}
				onClick={(e) => {
					e.stopPropagation();
					if (is_loading || _disabled) return;
					_onClick ? _onClick(e) : '';
				}}
				ref={_ref}
				is_loading={is_loading}
			>
				<span>
					<CoreSvg _fill={_disabled ? theme.colors.gray.gray30 : undefined}>
						{children}
					</CoreSvg>
				</span>
			</IconButton>
		);

	return null;
};

export default CoreIconButton;

// props
// - color_type: primary(메인컬러), gray(다크)
// - style_type: filled, tonal, text (피그마 참고)
// - text: button 텍스트
// - !!!children!!!: 반드시 사용할 아이콘을 자식요소로 넣을 것!
